import React from 'react';
import { Neo, Views, NeoGrid } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import EventMappingVM from './EventMappingVM';
import EventMappingLookup from '../Models/EventMappingLookup';
import RunInterceptionComponent from '../../../Common/Components/Interception/RunInterceptionComponent';
import AssignEventComponent from '../components/AssignEventComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { EventMapping } from '../../../AccessControl/Models/Commands/Security/Roles';
import { InterceptionProcessEnum } from '../../../Common/Enums/InterceptionProcessEnum';

@observer
export default class EventMappingView extends Views.ViewBase<EventMappingVM> {
    constructor(props: unknown) {
        super("Event Mapping", EventMappingVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showAssignEventMappingComponent &&
                    <AssignEventComponent
                        viewModel={this.viewModel.assignEventMappingVM}
                        eventMappingUpdateList={this.viewModel.eventMappingUpdateList}
                        onBack={() => this.viewModel.backToEventMapping()}
                        onSave={() => this.viewModel.updateEventMapping()}
                        onEventSearch={() => this.viewModel.onAssignEventSearch()} 
                        onCreationOfNewEvent={() => this.viewModel.saveNewEvent()}/>}

                {this.viewModel.showAssignEventMappingComponent === false &&
                    <>
                        <Neo.Card title={TextConstants.Titles.EventMapping} className="m-1">
                            <Neo.Form onSubmit={() => this.viewModel.genericEventMappingCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <Neo.FormGroup className="form-search" bind={this.viewModel.genericEventMappingCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchEventMapping}
                                    suppressLabel={true}
                                    append={<Neo.Button isSubmit>
                                        <i className={`${this.viewModel.genericEventMappingCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                    </Neo.Button>} />
                            </Neo.Form>
                            {this.viewModel.authorisationService.hasRole(EventMapping.Edit) &&
                                <div className="row text-left">
                                    <div className="col-lg-2">
                                        <div className="btn-inline pb-3 pt-0">
                                            <Neo.Button variant="primary"
                                                disabled={this.viewModel.eventMappingUpdateList.length === 0}
                                                onClick={() => this.viewModel.displayAssignEventMappingComponent()}>
                                                {TextConstants.Buttons.MapEvent}
                                            </Neo.Button>
                                        </div>
                                    </div>
                                </div>
                            }
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <NeoGrid.Grid<EventMappingLookup> className={"table-striped"}>
                                    {(item, meta) => (
                                        <NeoGrid.Row key={item.genericEventMappingID}>
                                            {this.viewModel.authorisationService.hasRole(EventMapping.Select) &&
                                                <NeoGrid.Column bind={meta.selected} type="select" onChange={() => { this.viewModel.populateMappedObject(item) }} sort={false} label={TextConstants.Labels.Select} />
                                            }
                                            <NeoGrid.Column display={meta.stockBroker} label={TextConstants.Labels.Broker} />
                                            <NeoGrid.Column display={meta.staticEventName} label={TextConstants.Labels.EventName} />
                                            <NeoGrid.Column display={meta.securityOrCash} />
                                            <NeoGrid.Column display={meta.fileType} />
                                            <NeoGrid.Column display={meta.eventType} />
                                            <NeoGrid.Column display={meta.corporateActionType} />
                                            <NeoGrid.Column display={meta.adhocBookingType} />
                                            <NeoGrid.Column display={meta.buyOrSell} />
                                            <NeoGrid.Column display={meta.isPositiveValue} />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>
                        </Neo.Card>

                        {this.viewModel.authorisationService.hasRole(EventMapping.RunInterception) &&
                            <RunInterceptionComponent
                                viewModel={this.viewModel.runInterceptionVM}
                                interceptionStoredProcedure={InterceptionProcessEnum.Event} />}
                    </>
                }
            </>
        );
    }
}